export default __webpack_public_path__ + "static/media/notes.0cfce69d.png";